import { fetch } from 'utils/fetch';

/*
taskName 任务名称
taskCode	任务编码
keyword 关键词
enabled 启用禁用
expenseTypeId 费用类型id
formType 表单大类
formOID 表单oid
businessDate 业务日期
documentId 当前单据唯一标识（用于独占）
projectTypeIds 项目类型id数组
applicantOID: PropTypes.string, // 申请人userOID
 */
export const getAllProjectTask = (data) => {
  return fetch({
    url: '/api/project/task/common/search',
    method: 'post',
    data,
  });
};

export const getProjectTaskDetail = (costCenterItemOID) => {
  return fetch({
    url: `/api/project/task/card/detail?costCenterItemOID=${costCenterItemOID}`,
    method: 'get',
  });
};
